import {
  CUSTOMER_LIST_FRAGMENT,
  CUSTOMER_PAYOUT_ACCOUNT_FRAGMENTS,
} from "./fragments";

export const SEARCH_CUSTOMER_LIST = `
${CUSTOMER_LIST_FRAGMENT}
query SearchCustomer($q: String!, $page: ID!, $numberPerPage: ID) {
  customerSearch(q: $q, page: $page, numberPerPage: $numberPerPage) {
    count
    results {
      ...CustomerListParts
    }
    errors {
      property
      description
    }
  }
}
`;

export const GLOBAL_SEARCH_CUSTOMER = `
query GlobalSearchCustomer($q: String!, $page: ID!, $numberPerPage: ID) {
  customerSearch(q: $q, page: $page, numberPerPage: $numberPerPage) {
    count
    results {
      id
      petraId
      firstName
      middleName
      lastName
      ssnitNumber
      fullname
      customerEmails {
        email {
          address
        }
        isPrimary
      }
      activeCustomerPhones {
        phone {
          number
        }
        isPrimary
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const HOLD_CUSTOMER_INTERACTION = `
mutation HoldCustomerInteraction($customerInteractionId: ID!) {
  holdCustomerInteraction(customerInteractionId: $customerInteractionId){
    customerInteraction {
      id
      status
    }
    errors {
      property
      description
    }
  }
}
`;

export const OPEN_CUSTOMER_INTERACTION = `
mutation OpenCustomerInteraction($customerInteractionId: ID!) {
  openCustomerInteraction(customerInteractionId: $customerInteractionId){
    customerInteraction {
      id
      status
    }
    errors {
      property
      description
    }
  }
}
`;

export const CLOSE_CUSTOMER_INTERACTION = `
mutation CloseCustomerInteraction($customerInteractionId: ID!, $closureType: String!, $templateId: ID, $transferRequestId: Int, $sendSurvey: Boolean, $customComment: String, $recipientOverride: String) {
  closeCustomerInteraction(customerInteractionId: $customerInteractionId, closureType: $closureType, templateId: $templateId, transferRequestId: $transferRequestId, sendSurvey: $sendSurvey, customComment: $customComment, recipientOverride: $recipientOverride){
    customerInteraction {
      id
      status
      closedAt
      closedBy
      closureType
      interactionCategory
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_CUSTOMER_INTERACTION_NOTIFICATION_PREVIEW = `
query GetCustomerInteractionNotificationPreview($customerInteractionId: ID!, $templateId: ID!, $comment: String) {
  customerInteractionDelayUpdatePreview(customerInteractionId: $customerInteractionId, templateId: $templateId, comment: $comment) {
    preview {
      templateName
      templateType
      notificationType
      recipient
      subject
      body
    }
    errors {
      property
      description
    }
  }
}
`;

export const SEND_CUSTOMER_INTERACTION_DELAY_UPDATE = `
mutation SendCustomerInteractionDelayUpdate($customerInteractionId: ID!, $templateId: ID!, $comment: String) {
  sendCustomerInteractionDelayUpdate(customerInteractionId: $customerInteractionId, templateId: $templateId, comment: $comment) {
    customerInteraction {
      id
      status
      revertDate
    }
    notifierRecord {
      id
      status
      notificationType
      recipient
      message
      createdAt
    }
    errors {
      property
      description
    }
  }
}
`;

export const CREATE_CUSTOMER_LIEN = `
mutation CreateCustomerLien($currentAmount: Float!, $customerSubscriptionId: ID!, $totalAmount: Float!, $startDate: String!, $endDate: String!, $provider: String!, $loanPaid: Boolean!, $employeePreTax: Float, $employeePostTax: Float, $employerPreTax: Float, $employerPostTax: Float, $lienAttachmentUrl: String!, $companyId: ID!) {
  createCustomerLien(currentAmount: $currentAmount, customerSubscriptionId: $customerSubscriptionId, totalAmount: $totalAmount, startDate: $startDate, endDate: $endDate, provider: $provider, loanPaid: $loanPaid, employeePreTax: $employeePreTax, employeePostTax: $employeePostTax, employerPreTax: $employerPreTax, employerPostTax: $employerPostTax, lienAttachmentUrl: $lienAttachmentUrl, companyId: $companyId) {
      customerLien {
      currentAmount
      id
      totalAmount
      startDate
      endDate
      lienAttachmentUrl
      customerSubscription {
        id
      }
    }
    errors {
      description
      property
    }
  }
}
`;

export const UPDATE_CUSTOMER_LIEN = `
mutation UpdateCustomerLien($id: ID!, $currentAmount: Float!, $customerSubscriptionId: ID!, $totalAmount: Float!, $startDate: String!, $endDate: String!, $provider: String!, $loanPaid: Boolean!, $employeePreTax: Float, $employeePostTax: Float, $employerPreTax: Float, $employerPostTax: Float, $lienAttachmentUrl: String!, $companyId: ID!) {
  updateCustomerLien(id: $id, currentAmount: $currentAmount, customerSubscriptionId: $customerSubscriptionId, totalAmount: $totalAmount, startDate: $startDate, endDate: $endDate, provider: $provider, loanPaid: $loanPaid, employeePreTax: $employeePreTax, employeePostTax: $employeePostTax, employerPreTax: $employerPreTax, employerPostTax: $employerPostTax, lienAttachmentUrl: $lienAttachmentUrl, companyId: $companyId) {
    customerLien {
      currentAmount
      id
      totalAmount
      startDate
      endDate
      lienAttachmentUrl
      customerSubscription {
        id
      }
    }
  errors {
      description
      property
    }
  }
}
`;

export const DELETE_CUSTOMER_LIEN = `
mutation DeleteCustomerLien($lienId: ID!) {
  deleteCustomerLien(lienId: $lienId) {
    result
    errors {
      description
      property
    }
  }
}
`;

export const CREATE_CUSTOMER_TICKET = `
mutation CreateCustomerInteractionTicket($source: String!, $properties: JSON!, $customerInteractionId: String!, $assigneeId: ID,  $ticketSubCategoryId: ID) {
  createCustomerInteractionTicket(source: $source, properties: $properties, customerInteractionId: $customerInteractionId, assigneeId: $assigneeId, ticketSubCategoryId: $ticketSubCategoryId){
    ticket {
      id
      properties
      reference
      source
      url
      number
      state
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_NOTE_TO_CUSTOMER_INTERACTION = `
  mutation AssignNoteToCustomerInteraction($noteId: ID!, $customerInteractionId: ID!){
    assignNoteToCustomerInteraction(noteId: $noteId, customerInteractionId: $customerInteractionId) {
      customerInteractionNote {
        note {
          id
          description
          user {
            id
            name
          }
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const ASSIGN_ATTACHMENT_TO_CUSTOMER_INTERACTION = `
  mutation AssignAttachmentsToCustomerInteraction($attachmentIds: [ID!]!, $customerInteractionId: ID!) {
    assignAttachmentsToCustomerInteraction(attachmentIds: $attachmentIds, customerInteractionId: $customerInteractionId) {
      customerInteraction {
        id
        activityDate
        description
        status
        complaintType
        contactInformation
        preferredCommMode
        customerInteractionAttachments {
          id
          attachment {
            id
            url
            name
          }
        }
        desiredOutcome
        notes {
          id
          description
          user {
            id
            name
          }
        }
        customer {
          id
          firstName
        }
        user {
          id
          name
        }
        subCategory {
          id
          name
          longName
        }
        interactionSource {
          id
          name
        }
      }
    }
  }
`;

export const MERGE_CUSTOMERS = `
  mutation MergeCustomers($mainId: ID!, $duplicateId: ID!) {
    mergeCustomers(mainId: $mainId, duplicateId: $duplicateId){
      result
      errors {
        property
        description
      }
      customer {
        id
      }
    }
  }
`;

export const REVERSE_MERGE_CUSTOMERS = `
  mutation ReverseMergeCustomers($mainId: ID!, $duplicateId: ID!) {
    reverseMergeCustomers(mainId: $mainId, duplicateId: $duplicateId) {
      result
      errors {
        property
        description
      }
      customer {
        id
      }
    }
  }
`;

export const BULK_REVERSE_MERGE_CUSTOMERS = `
  mutation BulkReverseMergeCustomers($mainId: ID!, $duplicateIds: [ID!]) {
    bulkReverseMergeCustomers(mainId: $mainId, duplicateIds: $duplicateIds) {
      result
      errors {
        property
        description
      }
      customer {
        id
      }
    }
  }
`;

export const GET_CUSTOMER_CHANGELOG = `
query GetCustomerChangeLog($customerId: ID!) {
  customerChangeLogs(customerId: $customerId) {
    auditItem
    createdAt
    user
    comment
    action
  }
}
`;

export const GET_CUSTOMER_INTERACTION_CHANGELOG = `
query GetCustomerInteractionChangeLog($customerInteractionId: ID!) {
  customerInteractionChangeLogs(customerInteractionId: $customerInteractionId) {
    auditItem
    createdAt
    comment
    user
    comment
    action
  }
}
`;

export const GET_CUSTOMER_INTERACTIONS_QUERY = `
query GetCustomerInteractions($customerId: ID!,  $page: String) {
  interactionsForCustomer(customerId: $customerId, page: $page) {
    count
    results {
      id
        activityDate
        description
        dueDate
        closedBy
        comment
        closedAt
        closureType
        closureMetadata
        status
        interactionCategory
        complaintType
        contactInformation
        sourceContactInformation
        preferredCommMode
        revertDate
        customerInteractionAttachments {
          id
          attachment {
            id
            url
            name
          }
        }
        customerInteractionTickets {
          id
          ticket {
            id
            properties
            reference
            source
            url
            number
            state
          }
        }
        desiredOutcome
        contactInformation
        notes {
          id
          description
          user {
            id
            name
          }
          createdAt
          updatedAt
        }
        customer {
          id
          firstName
        }
        user {
          id
          name
        }
        subCategory {
          id
          name
          longName
        }
        interactionSource {
          id
          name
        }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_CUSTOMER_SUBSCRIPTIONS = `
query GetCustomer($customerId: ID!) {
  customer(id: $customerId) {
    customerSubscriptions {
      id
      createdAt
      productDuration
      computedFirstContributionDate
      updateComputedFirstContributionDate
      firstTierContributionDate
      firstSchemeContributionDate
      firstContributionDate
      proofOfContributionDocumentUrl
      brokerageProductId
      salesPerson {
        id
        name
      }
      customerPayoutAccounts {
        ...CustomerPayoutAccountParts
        customerSubscription {
          id
        }
      }
      customerVan {
        id
        van
        oldVan
        financialInstitution {
          id
          name
        }
      }
      customerBeneficiaries {
        id
        beneficiaryType
        firstName
        middleName
        lastName
        ghanaCardUrl
        ghanaCardBackUrl
        idExpiryDate
        idIssueDate
        isActive
        deletedAt
        fullname
        customerSubscription{
          id
        }
        idType {
          id
          name
        }
        title {
          id
          name
        }
        idNumber
        dateOfBirth
        benefitsPercentage
        emailAddress
        phoneNumber
        guardianName
        guardianAddress
        guardianPhoneNumber
        guardianEmail
        institutionName
        institutionAddress
        institutionPhoneNumber
        beneficiaryAmount
        customerRelationship {
          id
          name
        }
      }
      product {
        id
        name
        isActive
        fundCode
        productTier {
          name
        }
        opportunityProspect {
          name
        }
      }
      customerLiens {
        id
        loanRequest {
            id
          }
        currentAmount
        totalAmount
        loanPaid
        provider
        employeePreTax
        employeePostTax
        employerPreTax
        employerPostTax
        startDate
        endDate
        lienAttachmentUrl
        company {
            id
            name
        }
        changeLogs {
          auditItem
          user
          action
          createdAt
        }
      }
      customerSubscriptionTags {
        id
        tag {
          id
          name
        }
      }
    }
  }
}
${CUSTOMER_PAYOUT_ACCOUNT_FRAGMENTS}
`;

export const GET_CUSTOMER_NAME_AND_SEGMENT_QUERY = `
query GetCustomerNameAndSegment($customerId: ID!) {
  customer(id: $customerId) {
    id
    fullname
    customerSegment
  }
}
`;

export const GET_CUSTOMER_QUERY = `
query GetCustomer($customerId: ID!) {
  customer(id: $customerId) {
    id
    petraId
    firstName
    middleName
    lastName
    fullname
    ghanaCardVerifiedAt
    isGhanaCardVerified
    isDobVerified
    dobVerifiedAt
    verificationProofUrl
    customerBackgroundInformation{
      fatherName
      fatherDeceased
      fatherPhoneNumber
      motherName
      motherDeceased
      motherPhoneNumber
      previousSsnitNumber
      hometown
      nextOfKinName
      nextOfKinPhoneNumber
      previousEmployer
    }
    customerInfoFileUploads{
      id
      url
      fileType
    }
    ssnitNumber
    gender
    mergedTo {
      id
      fullname
    }
    mergedFrom {
      id
      fullname
    }
    maritalStatus {
      id
      name
    }
    dateOfBirth
    signatureUrl
    photoIdUrl
    idType {
      id
      name
    }
    title {
      id
      name
    }
    photoIdNumber
    ghanaCardIdUrl
    ghanaCardIdBackUrl
    ghanaCardNo
    isDobVerified
    idIssueDate
    idExpiryDate
    merged
    customerSegment
    formerCompanies {
      id
      name
      industrySector {
        name
      }
      petraId
      tinNumber
      tags {
        id
        name
      }
      authorizers {
        id
        contactName
        emailAddress
      }
    }
    customerMergeLogs {
      id
      createdAt
      duplicateCustomer {
        id
        petraId
        fullname
      }
    }
    country {
      id
      name
    }
    tags {
      id
      name
    }
    exclusionListTags {
      id
      name
    }
    customerAddresses {
      id
      address {
        id
        streetName
        ghPost
        poBox
        region
        city
        isPostalBox
        country {
          id
          name
        }
      }
      isPrimary
      isActive
    }
    customerEmails {
      id
      email {
        id
        address
      }
      isPrimary
      isActive
    }
    activeCustomerPhones {
      id
      phone {
        id
        number
        type
      }
      isPrimary
      isActive
    }
    employers {
      id
      name
      industrySector {
        name
      }
      petraId
      tinNumber
      tags {
        id
        name
      }
      authorizers {
        id
        contactName
        emailAddress
      }
    }
    opportunities {
      id
      customerSubscriptions {
        id
        createdAt
        product {
          id
          name
          fundCode
        }
        productDuration
        customerLiens {
          id
          loanRequest {
            id
          }
          currentAmount
          totalAmount
          loanRequest {
            id
          }
          loanPaid
          provider
          employeePreTax
          employeePostTax
          employerPreTax
          employerPostTax
          startDate
          endDate
          lienAttachmentUrl
          company {
            id
            name
          }
          changeLogs {
            auditItem
            user
            action
            createdAt
          }
        }
        customerBeneficiaries {
          id
          beneficiaryType
          firstName
          ghanaCardUrl
          ghanaCardBackUrl
          idExpiryDate
          idIssueDate
          middleName
          lastName
          fullname
          isActive
          deletedAt
          idType {
            id
            name
          }
          title {
            id
            name
          }
          idNumber
          dateOfBirth
          benefitsPercentage
          emailAddress
          phoneNumber
          guardianName
          guardianAddress
          guardianPhoneNumber
          guardianEmail
          institutionName
          institutionAddress
          institutionPhoneNumber
          customerRelationship {
            id
            name
          }
        }
      }
      opportunityInteractions {
        id
        description
        interactionDate
        interactionMode {
          id
          name
        }
      }
      product {
        id
        name
      }
    }
    customerDebitAccounts {
      id
      name
      isVerified
      institutionName
      accountNumber
      accountType
      bankAccountType
      amount
      expirationDate
      authorizationFormUrl
      customerSubscription {
        id
        product {
          id
          name
          isActive
        }
      }
      bankBranch {
        id
        name
        financialInstitution {
          id
          name
        }
        sortCode
      }
    }
    customerPayoutAccounts {
      id
      name
      institutionName
      accountNumber
      accountType
      isPayoutAccountVerified
      payoutAccountVerifiedAt
      customerSubscription{
        id
        product {
          id
          name
          isActive
        }
      }
      customer {
        id
      }
      bankBranch {
        id
        name
        financialInstitution {
          id
          name
        }
        sortCode
      }
    }
    customerSubscriptions {
      id
      createdAt
      updateComputedFirstContributionDate
      brokerageProductId
      salesPerson {
        id
        name
      }
      customerPayoutAccounts {
        id
        accountNumber
        accountType
        institutionName
        name
        isPayoutAccountVerified
        payoutAccountVerifiedAt
        payoutAccount {
          id
          name
          accountNumber
          accountType
          bankBranch {
            id
            name
            financialInstitution {
              id
              name
            }
          }
        }
        bankBranch {
          id
          name
          financialInstitution {
            id
            name
          }
          sortCode
        }
        customerSubscription {
          id
          product {
            id
            name
          }
        }
      }
      customerVan {
        id
        van
        oldVan
        financialInstitution {
          id
          name
        }
      }
      customerBeneficiaries {
          id
          beneficiaryType
          firstName
          ghanaCardUrl
          ghanaCardBackUrl
          idExpiryDate
          idIssueDate
          middleName
          lastName
          fullname
          isActive
          deletedAt
          idType {
            id
            name
          }
          title {
            id
            name
          }
          idNumber
          dateOfBirth
          benefitsPercentage
          emailAddress
          phoneNumber
          guardianName
          guardianAddress
          guardianPhoneNumber
          guardianEmail
          institutionName
          institutionAddress
          institutionPhoneNumber
          customerSubscription{
            id
            product {
              name
            }
          }
          beneficiaryAmount
          customerRelationship {
            id
            name
          }
      }
      product {
        id
        name
        isActive
        fundCode
        opportunityProspect{
          name
        }
        productTier {
          id
          name
        }
        productCategory {
          id
          name
        }
      }
      productDuration
      customerLiens {
        id
        loanRequest {
          id
        }
        currentAmount
        totalAmount
        loanPaid
        provider
        employeePreTax
        employeePostTax
        employerPreTax
        employerPostTax
        startDate
        endDate
        lienAttachmentUrl
        company {
            id
            name
        }
        changeLogs{
          auditItem
          user
          action
          createdAt
        }
      }
      customerSubscriptionTags {
        id
        tag {
          id
          name
        }
      }
    }
    ussdAccount {
      id
      accountStatus
      hashedPin
      phone {
        number
      }
    }
    memberPortalAccount {
      id
      username
      registrationStatus
    }
    customerCompanyAssociations{
      id
      company{
        id
        name
        petraId
        companySubscriptions {
          id
          product {
            id
            name
          }
        }
      }
      dateOfEmployment
      influenceLevel
      isEmployee
      isActive
      relationship
      staffId
      natureOfEmployment
      frequencyOfIncome
    }
  }
}
`;

export const GET_CUSTOMER_SELF_ACTIVITIES_QUERY = `
query GetCustomer($customerId: ID!) {
  customer(id: $customerId) {
    selfServiceActivities {
      id
      customer {
        id
        lastName
        firstName
      }
      description
      channel
      category
      subCategory
      updatedAt
    }
  }
}
`;

export const GET_CUSTOMER_NOTIFIER_RECORDS_QUERY = `
query GetCustomer($customerId: ID!) {
  customer(id: $customerId) {
    notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
      customer{
        id
        petraId
      }
    }
  }
}
`;

export const GET_CUSTOMER_ONLINE_TRANSACTIONS = `
query GetCustomerTransactions($customerId: ID!) {
  customerTransactions(customerId: $customerId) {
    id
    description
    provider
    mode
    priceDate
    totalAmount
    status
    transactionType
    createdAt
    customerSubscription {
      product {
        id
        name
        fundCode
      }
    }
  }
}
`;

export const GENERATE_CUSTOMER_STATEMENT = `
query GenerateCustomerStatement($startDate: String!, $endDate: String!, $customerSubscriptionId: ID!, $companyId: ID!) {
  generateCustomerStatement(startDate:$startDate, endDate:$endDate, customerSubscriptionId:$customerSubscriptionId, companyId: $companyId) {
    url
    error
  }
}
`;

export const GET_CUSTOMER_SCHEMES = `
query GetAllCustomerSchemes($customerPetraId: String!, $clientPetraId: String, $startDate: String, $endDate: String) {
  getAllSchemesExtended(customerPetraId: $customerPetraId, clientPetraId: $clientPetraId, startDate: $startDate, endDate:$endDate){
    name
    balance
    product
    redemptions
    redeemableBalance
    pending
    contributions
    employers
    liens
    dateJoinedScheme
    totalContributions
  }
}
`;

export const GET_CUSTOMER_SCHEME_EXTENDED = `
query GetCustomerExtendedScheme($customerPetraId: String!, $fundCode: String!, $clientPetraId: String, $startDate: String, $endDate: String) {
  getSchemeExtended(customerPetraId: $customerPetraId, fundCode: $fundCode, clientPetraId: $clientPetraId, startDate: $startDate, endDate:$endDate){
    name
    balance
    redemptions
    redeemableBalance
    pending
  }
}
`;

export const GET_CUSTOMER_TICKETS = `
query GetCustomerPhoenixTickets($customerId: ID!) {
  customer(id: $customerId) {
    tickets{
      id
      properties
      url
      reference
      number
      state
    }
  }
}
`;

export const UPDATE_CUSTOMER_SUBSCRIPTION = `
 mutation updateCustomerSubscription($customerSubscriptionId: ID!, $salesPersonId: ID,  $firstContributionDate: String, $proofOfContributionDocumentUrl: String){
  updateCustomerSubscription(customerSubscriptionId: $customerSubscriptionId, salesPersonId: $salesPersonId, firstContributionDate: $firstContributionDate, proofOfContributionDocumentUrl: $proofOfContributionDocumentUrl ) {
    customerSubscription{
      id
      salesPerson{
        id
        name
      }
    }
    errors{
      description
      property
    }
  }
 }
`;

export const DELETE_CUSTOMER_SUBSCRIPTION = `
 mutation deleteCustomerSubscription($id: ID!){
  deleteCustomerSubscription(id: $id ) {
    result
    errors{
      description
      property
    }
  }
 }
`;

export const UPDATE_CUSTOMER_INTERACTION = `
  mutation UpdateCustomerInteraction($id:ID!, $customerId: ID!, $subCategoryId: ID!,  $userId: ID!, $description: String!, $interactionSourceId: ID!, $preferredCommMode: String, $contactInformation:String, $desiredOutcome: String, $complaintType: String, $sourceContactInformation: String, $revertDate: String, $comment: String!) {
    updateCustomerInteraction(id: $id, customerId: $customerId, subCategoryId: $subCategoryId, userId: $userId, description: $description, interactionSourceId: $interactionSourceId, preferredCommMode: $preferredCommMode, contactInformation: $contactInformation,  desiredOutcome: $desiredOutcome, complaintType: $complaintType, sourceContactInformation: $sourceContactInformation, revertDate: $revertDate, comment: $comment){
      customerInteraction {
        id
        description
        status
        activityDate
        revertDate
        dueDate
        comment
        interactionCategory
        complaintType
        contactInformation
        preferredCommMode
        desiredOutcome
        sourceContactInformation
        customerInteractionAttachments {
          id
          attachment {
            id
            url
            name
          }
        }
        customerInteractionTickets {
          id
          ticket {
            id
            properties
            reference
            source
            url
            number
            state
          }
        }
        notes {
          id
          description
          user {
            id
            name
          }
        }
        customer {
          id
          firstName
        }
        subCategory {
          id
          name
          longName
        }
        interactionSource {
          id
          name
        }
        user {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_CUSTOMER_INTERACTION = `
  mutation CreateInteraction($customerId: ID!, $subCategoryId: ID!,  $userId: ID!, $description: String!, $activityDate: String, $interactionSourceId: ID!, $interactionCategory: String!, $preferredCommMode: String, $contactInformation:String, $desiredOutcome: String, $complaintType: String, $sourceContactInformation: String!, $interactionResolved: Boolean!, $createTicket: Boolean, $subscriberIds: [ID!], $assigneeId: ID, $ticketSubCategoryId: ID, $ticketDescription: String, $attachmentIds: [ID!]) {
    createCustomerInteraction(customerId: $customerId, subCategoryId: $subCategoryId, userId: $userId, description: $description, activityDate: $activityDate, interactionSourceId: $interactionSourceId, interactionCategory: $interactionCategory, preferredCommMode: $preferredCommMode, contactInformation: $contactInformation,  desiredOutcome: $desiredOutcome, complaintType: $complaintType, sourceContactInformation: $sourceContactInformation,interactionResolved: $interactionResolved, createTicket: $createTicket, subscriberIds: $subscriberIds, assigneeId: $assigneeId, ticketSubCategoryId: $ticketSubCategoryId, ticketDescription: $ticketDescription, attachmentIds: $attachmentIds){
      customerInteraction {
        id
        description
        status
        activityDate
        revertDate
        dueDate
        interactionCategory
        complaintType
        contactInformation
        preferredCommMode
        desiredOutcome
        sourceContactInformation
        customerInteractionAttachments {
          id
          attachment {
            id
            url
            name
          }
        }
        customerInteractionTickets {
          id
          ticket {
            id
            properties
            reference
            source
            url
            number
            state
          }
        }
        notes {
          id
          description
          user {
            id
            name
          }
          createdAt
          updatedAt
        }
        customer {
          id
          firstName
        }
        subCategory {
          id
          name
          longName
        }
        interactionSource {
          id
          name
        }
        user {
          id
          name
        }
      }
      errors {
          property
          description
      }
    }
  }
`;

export const CREATE_INTERACTION_CUSTOMER_SUBSCRIPTION = `
  mutation CreateInteractionCustomerCompanyAssociation($customerInteractionId: ID!, $customerSubscriptionId: ID!) {
    createInteractionCustomerSubscription(customerInteractionId: $customerInteractionId, customerSubscriptionId: $customerSubscriptionId){
      interactionCustomerSubscription {
        customerInteraction {
          id
        }
        customerSubscription {
          id
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_INTERACTION_CUSTOMER_COMPANY = `
  mutation CreateInteractionCustomerCompanyAssociation($customerCompanyAssociationId: ID!, $customerInteractionId: ID!) {
    createInteractionCustomerCompanyAssociation(customerInteractionId: $customerInteractionId, customerCompanyAssociationId: $customerCompanyAssociationId){
      interactionCustomerCompanyAssociation {
        customerInteraction {
          id
        }
        customerCompanyAssociation {
          id
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const SEARCH_CUSTOMER_BY_PETRAID = `
query SearchCustomer($q: String!) {
  findCustomerByPetraId(petraId: $q) {
    id
    petraId
    firstName
    middleName
    lastName
    ssnitNumber
    fullname
  }
}
`;

export const SEARCH_CUSTOMER = `
query SearchCustomer($q: String!, $page: ID!) {
  customerSearch(q: $q, page: $page) {
    count
    results {
      id
      petraId
      firstName
      middleName
      lastName
      ghanaCardIdUrl
      ghanaCardIdBackUrl
      isGhanaCardVerified
      employers {
        id
        name
        petraId
      }
      activeCustomerPhones {
        id
        phone {
          id
          number
          type
        }
        isPrimary
      }
      customerEmails {
        id
        isPrimary
        isActive
        email {
          id
          address
        }
      }
      customerSubscriptions {
        id
        product {
          id
          name
          isActive
          fundCode
        }
        computedFirstContributionDate
        firstTierContributionDate
        firstSchemeContributionDate
        proofOfContributionDocumentUrl
      }
      customerCompanyAssociations{
        id
        company{
          id
          name
          petraId
          companySubscriptions {
            id
            product {
              id
              name
            }
          }
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_CUSTOMER_PRODUCT_BALANCE = `
  query CustomerProductBalance($customerPetraId: String!, $fundCode: String!, $clientPetraId: String!, $externalReference: String, $priceDate: String){
    customerBalances(customerPetraId: $customerPetraId, fundCode: $fundCode, clientPetraId: $clientPetraId, externalReference: $externalReference, priceDate: $priceDate){
      amount
      units
      client
      customer
      pendingUnits
      shareClass
      redeemableAmount
      redeemableUnits
      contributionUnits
      contributionAmounts
      redeemableContributionAmounts
      redeemableContributionUnits
      price
      pendingRedemptionsAmount
      approvedRedemptionsAmount
      liens
      vestedPercentage
      vestingMessage
    }
  }
`;

export const SEARCH_CUSTOMER_MORE_INFO = `
query SearchCustomer($q: String!, $page: ID!) {
  customerSearch(q: $q, page: $page) {
    count
    results {
      id
      petraId
      firstName
      middleName
      age
      lastName
      activeCustomerPhones {
        id
        phone {
          id
          number
          type
        }
        isPrimary
      }
      customerEmails {
        id
        isPrimary
        isActive
        email {
          id
          address
        }
      }
      customerSubscriptions {
        id
        product {
          id
          name
          isActive
          opportunityProspect{
            name
          }
          fundCode
          taxWaiverRequired
          productTier {
            id
            name
          }
          productCategory {
            id
            name
          }
          assetMapId
        }
        productDuration
        customerLiens {
          id
          loanRequest {
            id
          }
          currentAmount
          totalAmount
          loanPaid
          provider
          employeePreTax
          employeePostTax
          employerPreTax
          employerPostTax
          startDate
          endDate
          lienAttachmentUrl
          company {
            id
            name
          }
        }
        customerPayoutAccounts {
          id
          accountNumber
          name
          accountType
          institutionName
          isPayoutAccountVerified
          payoutAccountVerifiedAt
          payoutAccount {
            id
            name
            accountNumber
            accountType
            bankBranch {
              id
              name
              financialInstitution {
                id
                name
              }
            }
          }
        }
      }
      customerPayoutAccounts {
        id
        accountNumber
        name
        accountType
        institutionName
        isPayoutAccountVerified
        payoutAccountVerifiedAt
        bankBranch {
          id
          name
          financialInstitution {
            id
            name
          }
        }
      }
      customerCompanyAssociations {
        company {
          id
          name
          petraId
        }
      }
      employers {
        id
        name
        industrySector {
          name
        }
        petraId
        tinNumber
        tags {
          id
          name
        }
        authorizers {
          id
          contactName
          emailAddress
        }
      }
      formerCompanies {
        id
        name
        industrySector {
          name
        }
        petraId
        tinNumber
        tags {
          id
          name
        }
        authorizers {
          id
          contactName
          emailAddress
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const CHECK_CUSTOMER_CONTRIBUTION = `
query CheckCustomerFirstContribution($waiveOffTax: Boolean!, $customerId: ID!) {
  checkCustomerFirstContribution(waiveOffTax: $waiveOffTax, customerId: $customerId)
}
`;

export const UNASSIGN_ADDRESS_FROM_CUSTOMER = `
mutation UnassignAddressFromCustomer($customerAddressId: ID!){
  unassignAddressFromCustomer(id: $customerAddressId){
    customerAddresses {
      id
      address {
        id
        streetName
        ghPost
        poBox
        region
        city
        country {
          id
          name
        }
      }
      isPrimary
      isActive
    }
    errors {
      property
      description
    }
  }
}
`;

export const UNASSIGN_PHONE_FROM_CUSTOMER = `
mutation UnassignPhoneFromCustomer($customerPhoneId: ID!){
  unassignPhoneFromCustomer(id: $customerPhoneId){
    activeCustomerPhones {
      id
      phone {
        id
        number
        type
      }
      isPrimary
      isActive
    }
    errors {
      property
      description
    }
  }
}
`;

export const UNASSIGN_EMAIL_FROM_CUSTOMER = `
mutation UnassignEmailFromCustomer($customerEmailId: ID!){
  unassignEmailFromCustomer(id: $customerEmailId){
    customerEmails{
      email{
        address
        id
      }
      id
      isActive
      isPrimary
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_CUSTOMER_TO_OPPORTUNITY = `
mutation AssignCustomerToOpportunity($customerId: ID!, $opportunityId: ID!) {
  assignCustomerToOpportunity(customerId: $customerId, opportunityId: $opportunityId){
    opportunity {
      customer {
        id
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_ADDRESS_TO_CUSTOMER = `
  mutation AssignAddressToCustomer( $addressId:ID!, $customerId:ID!) {
    assignAddressToCustomer(addressId: $addressId, customerId: $customerId ){
      customerAddress {
        id
        address {
          id
          streetName
          ghPost
          region
          poBox
          city
          country {
            id
            name
          }
        }
        isPrimary
        isActive
      }
      errors {
        property
        description
      }
    }
  }
`;

export const ASSIGN_EMAIL_TO_CUSTOMER = `
mutation AssignEmailToCustomer( $emailId:ID!, $customerId:ID!) {
  assignEmailToCustomer(emailId: $emailId, customerId: $customerId){
    customerEmail {
      id
      email {
        id
        address
      }
      isPrimary
      isActive
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_PHONE_TO_CUSTOMER = `
mutation AssignAddressToCustomer( $phoneId:ID!, $customerId:ID!) {
  assignPhoneToCustomer(phoneId: $phoneId, customerId: $customerId){
    customerPhone {
      id
      phone {
        id
        number
        type
      }
      isPrimary
      isActive
    }
    errors {
      property
      description
    }
  }
}
`;

export const UPDATE_CUSTOMER_MUTATION = `
  mutation UpdateCustomer($firstName: String!, $lastName: String, $middleName: String, $maritalStatusId: ID, $ssnitNumber: String, $gender: String!, $dateOfBirth: String, $customerId: ID!, $countryId: ID!, $photoIdUrl: String, $photoIdNumber: String, $idTypeId: ID, $signatureUrl: String, $titleId: ID, $ghanaCardNo: String, $ghanaCardIdUrl: String, $ghanaCardIdBackUrl: String, $idExpiryDate: String, $idIssueDate: String, $isDobVerified: Boolean, $isGhanaCardVerified: Boolean, $verificationProofUrl: String, $isVerified: Boolean) {
    updateCustomer(firstName: $firstName, lastName: $lastName, middleName: $middleName, maritalStatusId: $maritalStatusId, ssnitNumber: $ssnitNumber, gender: $gender, dateOfBirth: $dateOfBirth, id: $customerId, countryId: $countryId, photoIdUrl: $photoIdUrl, photoIdNumber: $photoIdNumber, idTypeId: $idTypeId, signatureUrl: $signatureUrl, titleId: $titleId, ghanaCardNo: $ghanaCardNo, ghanaCardIdUrl: $ghanaCardIdUrl, ghanaCardIdBackUrl: $ghanaCardIdBackUrl, idIssueDate: $idIssueDate, idExpiryDate: $idExpiryDate, isDobVerified: $isDobVerified, isGhanaCardVerified: $isGhanaCardVerified, verificationProofUrl: $verificationProofUrl, isVerified: $isVerified) {
      customer {
        id
        firstName
        lastName
        middleName
        ssnitNumber
        gender
        signatureUrl
        photoIdUrl
        ghanaCardIdUrl
        ghanaCardIdBackUrl
        ghanaCardNo
        idExpiryDate
        customerBackgroundInformation{
          fatherName
          fatherDeceased
          fatherPhoneNumber
          motherName
          motherDeceased
          motherPhoneNumber
          previousSsnitNumber
          hometown
          nextOfKinName
          nextOfKinPhoneNumber
          previousEmployer
        }
        idIssueDate
        idType {
          id
          name
        }
        title {
          id
          name
        }
        merged
        photoIdNumber
        country {
          id
        }
        maritalStatus {
          name
        }
        dateOfBirth
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_CUSTOMER_ADDRESS = `
mutation UpdateCustomerAddress($customerAddressId: ID!, $customerId: ID!, $addressId: ID!) {
  updateCustomerAddress(id: $customerAddressId, customerId: $customerId, addressId: $addressId){
    customerAddress {
      customer {
        customerAddresses {
          id
          address {
            id
            streetName
            ghPost
            region
            poBox
            city
            country {
              id
              name
            }
          }
          isPrimary
          isActive
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const UPDATE_CUSTOMER_EMAIL = `
mutation UpdateCustomerEmail($customerEmailId: ID!, $customerId: ID!, $emailId: ID!) {
  updateCustomerEmail(id: $customerEmailId, customerId: $customerId, emailId: $emailId){
    customerEmail {
      customer {
        customerEmails {
          id
          email {
            id
            address
          }
          isPrimary
          isActive
        }
      }
    }
    errors {
      property
      description
    }
  }
}`;

export const GET_SYNC_LOGS = `
query GetSyncLogs($entityType: String!, $entityId: ID!) {
  getSyncLogs(entityType: $entityType, entityId: $entityId) {
    additionalInfo
    status
    errorMessage
    syncedAt
  }
}
`;

export const SYNC_CUSTOMER_MANUALLY = `
mutation SyncCustomerManually($customerId: ID!) {
  syncCustomerManually(customerId: $customerId) {
    result
  }
}
`;

export const UPDATE_CUSTOMER_PHONE = `
mutation UpdateCustomerPhone($customerPhoneId: ID!, $customerId: ID!, $phoneId: ID!) {
  updateCustomerPhone(id: $customerPhoneId, customerId: $customerId, phoneId: $phoneId){
    customerPhone {
      customer {
        activeCustomerPhones {
          id
          phone {
            id
            number
            type
          }
          isPrimary
          isActive
        }
      }
    }
    errors {
      property
      description
    }
  }
}`;

export const ASSIGN_TAGS_TO_CUSTOMER = `
mutation AssignTagsToCustomer($customerId: ID!, $tagIds:[ID!]!){
  assignTagsToCustomer(customerId: $customerId, tagIds: $tagIds){
    customer {
      tags {
        id
        name
      }
      allCustomerTags {
        id
        isActive
        createdAt
        tag {
          id
          name
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_TAGS_TO_CUSTOMER_SUBSCRIPTION = `
mutation AssignTagsToCustomerSubscription($tagIds: [ID!]!, $customerSubscriptionId:ID!){
  assignTagsToCustomerSubscription(tagIds: $tagIds, customerSubscriptionId: $customerSubscriptionId){
    customerSubscription {
      customerSubscriptionTags {
        tag {
          id
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_CUSTOMER_TAGS = `
query GetCustomerTags($customerId: ID!) {
  customer(id: $customerId) {
    allCustomerTags {
      id
      isActive
      createdAt
      tag {
        id
        name
      }
    }
  }
}
`;

export const CUSTOMER_INTERACTIONS_QUERY = `
query GetCustomerInteractions($page: ID!, $q: String!, $numberPerPage: Int) {
  customerInteractionSearch(page: $page, q: $q, numberPerPage: $numberPerPage) {
    count
    errors {
      description
      property
    }
    results {
      id
      activityDate
      dueDate
      closedAt
        closureType
      closureMetadata
      closedBy
      description
      status
      interactionCategory
      complaintType
      contactInformation
      preferredCommMode
      sourceContactInformation
      customerInteractionAttachments {
        id
        attachment {
          id
          url
          name
        }
      }
      customerInteractionTickets {
        id
        ticket {
          id
          properties
          reference
          source
          url
          number
          state
        }
      }
      desiredOutcome
      notes {
        id
        description
        user {
          id
          name
        }
        createdAt
        updatedAt
      }
      customer {
        id
        firstName
        petraId
      }
      user {
        id
        name
      }
      subCategory {
        id
        name
        longName
      }
      interactionSource {
        id
        name
      }
    }
  }
}
`;

export const CUSTOMER_INTERACTIONS_GLOBAL_SEARCH_QUERY = `
query GetCustomerInteractions($page: ID!, $q: String!, $numberPerPage: Int) {
  customerInteractionSearch(page: $page, q: $q, numberPerPage: $numberPerPage) {
    count
    errors {
      description
      property
    }
    results {
      id
      status
      activityDate
      description
      interactionSource {
        id
        name
      }
      customer {
        id
        fullname
      }
    }
  }
}
`;

export const GET_CUSTOMER_INTERACTION_QUERY = `
query GetCustomerInteraction($interactionId: ID!) {
  customerInteraction(id: $interactionId) {
      id
      activityDate
      dueDate
      closedAt
        closureType
      closureMetadata
      closedBy
      description
      revertDate
      status
      comment
      interactionCategory
      complaintType
      contactInformation
      preferredCommMode
      sourceContactInformation
      customerInteractionAttachments {
        id
        attachment {
          id
          url
          name
        }
      }
      customerInteractionTickets {
        id
        ticket {
          id
          properties
          reference
          source
          url
          number
          state
        }
      }
      desiredOutcome
      notes {
        id
        description
        user {
          id
          name
        }
        createdAt
        updatedAt
      }
      customer {
        id
        firstName
        petraId
      }
      user {
        id
        name
      }
      subCategory {
        id
        name
        longName
      }
      interactionSource {
        id
        name
      }
  }
}
`;

export const GET_ARCHIVED_CUSTOMERS = `
${CUSTOMER_LIST_FRAGMENT}
query archivedCustomerSearch($page: ID!, $q: String!, $numberPerPage: ID) {
  archivedCustomerSearch(page: $page, q: $q, numberPerPage: $numberPerPage) {
    count
    errors{
      description
      property
    }
    results{
        ...CustomerListParts
    }
  }
}
`;

export const CREATE_CUSTOMER_COMPANY_ASSOCIATION = `
mutation CreateCustomerCompanyAssociation ($customerId: ID!, $companyId: ID!, $relationship: String, $dateOfEmployment: String, $influenceLevel: String, $isEmployee: Boolean, $staffId: String, $natureOfEmployment: String, $frequencyOfIncome: String) {
  createCustomerCompanyAssociation(customerId: $customerId, companyId: $companyId, relationship: $relationship, dateOfEmployment: $dateOfEmployment, influenceLevel: $influenceLevel, isEmployee: $isEmployee, staffId: $staffId, natureOfEmployment: $natureOfEmployment, frequencyOfIncome: $frequencyOfIncome){
    customerCompanyAssociation {
      id
      influenceLevel
      relationship
      isEmployee
      dateOfEmployment
      staffId
      isActive
      natureOfEmployment
      frequencyOfIncome
      customer {
        id
      }
      company {
        id
        name
        petraId
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const UPDATE_CUSTOMER_COMPANY_ASSOCIATION = `
mutation UpdateCustomerCompanyAssociation ($id: ID!, $customerId: ID!, $companyId: ID!, $relationship: String, $dateOfEmployment: String, $influenceLevel: String, $isEmployee: Boolean, $isActive: Boolean, $staffId: String, $natureOfEmployment: String, $frequencyOfIncome: String) {
  updateCustomerCompanyAssociation(id: $id, customerId: $customerId, companyId: $companyId, relationship: $relationship, dateOfEmployment: $dateOfEmployment, influenceLevel: $influenceLevel, isEmployee: $isEmployee, isActive: $isActive, staffId: $staffId, natureOfEmployment: $natureOfEmployment, frequencyOfIncome: $frequencyOfIncome){
    customerCompanyAssociation {
      id
      influenceLevel
      relationship
      isEmployee
      isActive
      dateOfEmployment
      staffId
      natureOfEmployment
      frequencyOfIncome
      customer {
        id
      }
      company {
        id
        name
        petraId
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const DELETE_CUSTOMER_ASSOCIATION = `
mutation DeleteCustomerCompanyAssociation($id: ID!) {
  deleteCustomerCompanyAssociation(id: $id){
    customerCompanyAssociations{
      id
      company{
        id
        name
        petraId
        companySubscriptions {
          id
          product {
            id
            name
          }
        }
      }
      dateOfEmployment
      influenceLevel
      isEmployee
      isActive
      relationship
      staffId
      natureOfEmployment
      frequencyOfIncome
    }
    errors {
      property
      description
    }
  }
}
`;

export const REACTIVATE_CUSTOMER_ASSOCIATION = `
  mutation ReactivateCustomerCompanyAssociation($id: ID!) {
    reactivateCustomerCompanyAssociation(id: $id){
      customerCompanyAssociations{
        id
        company{
          id
          name
          petraId
          companySubscriptions {
            id
            product {
              id
              name
            }
          }
        }
        dateOfEmployment
        influenceLevel
        isEmployee
        isActive
        relationship
        natureOfEmployment
        frequencyOfIncome
        staffId
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_CUSTOMER_STATEMENTS = `
  query GetCustomerStatements($customerId: ID!) {
    getCustomerStatements(customerId: $customerId) {
      client
      dateSent
      emailResentAt
      emailSent
      period
      product
      smsResentAt
      smsSent
      url
    }
  }
`;

export const UPDATE_CUSTOMER_COMPANY_ASSOCIATION_EXTENDED = `
mutation UpdateCustomerCompanyAssociation($id: ID!, $companyId: ID!, $customerId: ID!, $relationship: String, $influenceLevel: String, $isEmployee: Boolean, $dateOfEmployment: String, $contactLevelIds: [ID!], $staffId: String ) {
  updateCustomerCompanyAssociation(id: $id, customerId: $customerId, companyId: $companyId, relationship: $relationship, influenceLevel: $influenceLevel, isEmployee: $isEmployee, dateOfEmployment: $dateOfEmployment, contactLevelIds: $contactLevelIds, staffId: $staffId){
    customerCompanyAssociation {
      staffId
      company {
        id
        contactPersons {
            id
            relationship
            influenceLevel
            dateOfEmployment
            staffId
            natureOfEmployment
            frequencyOfIncome
            customer {
              id
              firstName
              lastName
              title {
                id
                name
              }
              petraId
              gender
              customerEmails {
                email {
                  id
                  address
                }
              }
              activeCustomerPhones {
                phone {
                  id
                  number
                  type
                }
              }
              country {
                id
              }
            }
            customerCompanyAssociationContactLevels {
              id
              contactLevel {
                id
                name
                level
              }
            }
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_CUSTOMER_TO_COMPANY_MUTATION = `
mutation createCustomerCompanyAssociation($customerId: ID!, $companyId: ID!, $relationship: String, $influenceLevel: String, $isEmployee: Boolean, $dateOfEmployment: String, $contactLevelIds: [ID!], $staffId: String, $natureOfEmployment: String, $frequencyOfIncome: String) {
  createCustomerCompanyAssociation(customerId: $customerId, companyId: $companyId, relationship: $relationship, influenceLevel: $influenceLevel, isEmployee: $isEmployee, dateOfEmployment: $dateOfEmployment, contactLevelIds: $contactLevelIds, staffId: $staffId, natureOfEmployment: $natureOfEmployment, frequencyOfIncome: $frequencyOfIncome){
    customerCompanyAssociation {
      id
      relationship
      influenceLevel
      dateOfEmployment
      natureOfEmployment
      frequencyOfIncome
      staffId
      customer {
        id
        firstName
        lastName
        petraId
        gender
        title {
          id
          name
        }
        customerEmails {
          email {
            id
            address
          }
        }
        activeCustomerPhones {
          phone {
            id
            number
            type
          }
        }
        country {
          id
        }
      }
      company {
        id
      }
      customerCompanyAssociationContactLevels {
        id
        contactLevel {
          id
          name
          level
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const LOOKUP_USER = `
query LookupCustomer($phoneNumber: String!) {
  lookupCustomer(phoneNumber: $phoneNumber) {
    customer {
      id
      petraId
      firstName
      lastName
      title {
        id
        name
      }
      customerEmails {
        email {
          id
          address
        }
      }
      activeCustomerPhones {
        phone {
          id
          number
          type
        }
      }
    }
    isNewEntity
  }
}
`;

export const GET_FILE_OPTIONS_FOR_CUSTOMER = `
  query  {
    fileOptionsForCustomer {
      key
      value
    }
  }
`;

export const UNASSIGN_ATTACHMENT_FROM_CUSTOMER_INTERACTION = `
  mutation unassignAttachmentFromCustomerInteraction($id: ID!) {
    unassignAttachmentFromCustomerInteraction(id: $id) {
      result
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_CUSTOMER_BACKGROUND_INFORMATION = `
  mutation CreateCustomerBackgroundInformation(
    $customerId: ID!,
    $hometown: String,
    $previousSsnitNumber: String,
    $nextOfKinName: String,
    $nextOfKinPhoneNumber: String,
    $fatherName: String,
    $fatherDeceased: Boolean,
    $fatherPhoneNumber: String,
    $motherName: String,
    $motherDeceased: Boolean,
    $motherPhoneNumber: String,
    $previousEmployer: String
  ) {
    createCustomerBackgroundInformation(
      customerId: $customerId,
      hometown: $hometown,
      previousSsnitNumber: $previousSsnitNumber,
      nextOfKinName: $nextOfKinName,
      nextOfKinPhoneNumber: $nextOfKinPhoneNumber,
      fatherName: $fatherName,
      fatherDeceased: $fatherDeceased,
      fatherPhoneNumber: $fatherPhoneNumber,
      motherName: $motherName,
      motherDeceased: $motherDeceased,
      motherPhoneNumber: $motherPhoneNumber,
      previousEmployer: $previousEmployer
    ) {
      customerBackgroundInformation {
        hometown
        previousSsnitNumber
        nextOfKinName
        nextOfKinPhoneNumber
        fatherName
        fatherDeceased
        fatherPhoneNumber
        motherName
        motherDeceased
        motherPhoneNumber
        previousEmployer
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_CUSTOMER_BACKGROUND_INFORMATION = `
  mutation UpdateCustomerBackgroundInformation(
    $customerId: ID!,
    $hometown: String,
    $previousSsnitNumber: String,
    $nextOfKinName: String,
    $nextOfKinPhoneNumber: String,
    $fatherName: String,
    $fatherDeceased: Boolean,
    $fatherPhoneNumber: String,
    $motherName: String,
    $motherDeceased: Boolean,
    $motherPhoneNumber: String,
    $previousEmployer: String
  ) {
    updateCustomerBackgroundInformation(
      customerId: $customerId,
      hometown: $hometown,
      previousSsnitNumber: $previousSsnitNumber,
      nextOfKinName: $nextOfKinName,
      nextOfKinPhoneNumber: $nextOfKinPhoneNumber,
      fatherName: $fatherName,
      fatherDeceased: $fatherDeceased,
      fatherPhoneNumber: $fatherPhoneNumber,
      motherName: $motherName,
      motherDeceased: $motherDeceased,
      motherPhoneNumber: $motherPhoneNumber,
      previousEmployer: $previousEmployer
    ) {
      customerBackgroundInformation {
        hometown
        previousSsnitNumber
        nextOfKinName
        nextOfKinPhoneNumber
        fatherName
        fatherDeceased
        fatherPhoneNumber
        motherName
        motherDeceased
        motherPhoneNumber
        previousEmployer
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_CUSTOMER_REDEMPTION_REQUESTS = `
  query GetCustomerRedemptionRequests($customerId: ID!) {
    customer(id: $customerId) {
      redemptionRequests {
        id
        redemptionType
        redemptionValue
        redemptionAmount
        state
        requestDate
        customerSubscription {
          product {
            fundCode
            name
          }
        }
      }
    }
  }
`;

export const GET_CUSTOMER_TRANSFER_REQUESTS = `
  query GetCustomerTransferRequests($customerId: ID!) {
    customer(id: $customerId) {
      transferRequests {
        id
        requestDate
        transferType
        transferStatus
        trusteeScheme {
          id
          name
        }
        fromProduct {
          id
          name
        }
        toProduct {
          id
          name
        }
        user {
          id
          name
        }
        firstContributionDate
        customerInteraction {
          id
        }
      }
    }
  }
`;

export const GET_CUSTOMER_LOAN_REQUESTS = `
  query GetCustomerLoanRequests($customerId: ID!) {
    customer(id: $customerId) {
      loanRequests {
        id
        state
        loanType
        loanSecurityType
        loanAmountRequested
        loanTenureMonths
        source
        loanPurpose
        createdAt
        updatedAt
        provider {
          id
          name
        }
        product {
          id
          name
        }
        customerSubscription {
          id
          product {
            id
            name
          }
        }
        loanRequestKyc {
          id
          fullName
          email
          phoneNumber
          occupation
          monthlyIncome
        }
      }
    }
  }
`;

export const GET_CUSTOMER_FIXED_INCOME_REQUESTS = `
  query GetCustomer($customerId: ID!) {
    customer(id: $customerId) {
      fixedIncomeRequests {
        id
        createdAt
        updatedAt
        state
        source
        assignedTo {
          id
          name
        }
        provider {
          id
          name
        }
        product {
          id
          name
        }
      }
    }
  }
`;

export const GET_CUSTOMER_BALANCE_V2 = `
  query CustomerBalanceV2(
    $customerPetraId: String!
    $fundCode: String!
    $clientPetraId: String!
    $priceDate: ISO8601Date
  ) {
    customerBalanceV2(
      customerPetraId: $customerPetraId
      fundCode: $fundCode
      clientPetraId: $clientPetraId
      priceDate: $priceDate
    ) {
      allocations
      applicableAllocations
      lienDeductions
      pendingRedemptionDeductions
      price
      priceDate
      productName
      productTier
      redeemableAllocations
      schemeBalance
      schemeBeginningBalance
      schemePeriodIncome
      schemeRedeemableBalance
      schemeRedemptions
      schemeTotalContributions
      totalAllocations
      totalLienDeductions
      totalPendingRedemptionDeductions
      unvestedAllocations
      totalUnvestedAllocations
      totalRedeemableAllocations
      vestingComputations
      vestedAllocations
      totalVestedAllocations
      pendingRedemptionRequests {
        id
        requestDate
        state
        amountPaid
      }
      pendingCustomerTransactions {
        id
        transactionType
        status
        totalAmount
        createdAt
      }
    }
  }
`;
